import { Alert, Modal } from 'antd'
import { countryOptions } from '../utils'
import { useSignup } from '../SignupContext'

function countryLabel(code: string) {
  return countryOptions.find((option) => option.value === code)?.label ?? code
}

export default function AdvicePrepConfirmModal() {
  const {
    showAdvicePrepConfirmModal,
    setShowAdvicePrepConfirmModal,
    advicePrepPendingForm,
    confirmAdvicePrepAccount,
    runAction,
    loading,
    error,
    setError,
  } = useSignup()

  const handleCancel = () => {
    setError(null)
    setShowAdvicePrepConfirmModal(false)
  }

  const form = advicePrepPendingForm

  const rows: { label: string; value: string }[] = form
    ? [
        { label: 'Company', value: form.companyName },
        { label: 'Contact', value: `${form.firstName} ${form.lastName}`.trim() },
        { label: 'Email', value: form.email },
        { label: 'Country', value: countryLabel(form.code) },
        { label: 'Phone', value: form.phone || 'Not provided' },
        { label: 'Firm logo', value: form.logoFileName || 'Not provided' },
      ]
    : []

  return (
    <Modal
      open={showAdvicePrepConfirmModal}
      title="Confirm your details"
      okText="Confirm and continue"
      cancelText="Back to form"
      confirmLoading={loading}
      maskClosable={!loading}
      onCancel={handleCancel}
      onOk={() => void runAction(confirmAdvicePrepAccount, false)}
    >
      {error && <Alert type="error" showIcon className="mb-[0.875rem]" message={error} />}
      <p className="mb-[0.875rem] text-[0.8125rem] leading-[1.55] text-gray-600">
        Your account is created when you confirm. The email becomes your login and the company name cannot
        be changed here afterwards.
      </p>

      <div className="overflow-hidden rounded-[0.5rem] border border-gray-200">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex justify-between gap-[0.875rem] border-b border-gray-100 px-[0.8125rem] py-[0.5rem] text-[0.78125rem] last:border-b-0"
          >
            <span className="text-gray-500">{row.label}</span>
            <span className="min-w-0 break-words text-right font-medium text-gray-900">{row.value}</span>
          </div>
        ))}
      </div>

      <Alert
        type="info"
        showIcon
        className="mt-[0.875rem]"
        message="You are not charged yet. Payment comes after the next step."
      />
    </Modal>
  )
}
